import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { IngresarComponent } from './login/ingresar/ingresar.component';
import { RecuperarpasswordComponent } from './login/recuperarpassword/recuperarpassword.component';
import { PrincipalComponent } from './principal/principal.component';
import { GenerarqrComponent } from './principal/generarqr/generarqr.component';
import { MenuComponent } from './principal/menu/menu.component';
import { ReportesComponent } from './principal/reportes/reportes.component';
import { BannerComponent } from './principal/banner/banner.component';
import { NgxBootstrapIconsModule, allIcons, router } from 'ngx-bootstrap-icons';
import { QRCodeModule } from 'angularx-qrcode';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { ReporteDetalleComponent } from './principal/reportes/reporte-detalle/reporte-detalle.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ReporteDetallePaisComponent } from './principal/reportes/reporte-detalle/reporte-detalle-pais/reporte-detalle-pais.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { NgxPaginationModule } from 'ngx-pagination';
import { UsuarioComponent } from './principal/usuario/usuario.component';
import { BannerregistradosComponent } from './principal/banner/bannerregistrados/bannerregistrados.component';
import { BannerusuarioComponent } from './principal/banner/bannerusuario/bannerusuario.component';
import { LoadingComponent } from './loading/loading.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { FooterComponent } from './principal/footer/footer.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { RouterModule } from '@angular/router';
import { RedireccionComponent } from './principal/redireccion/redireccion.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    IngresarComponent,
    RecuperarpasswordComponent,
    PrincipalComponent,
    GenerarqrComponent,
    MenuComponent,
    ReportesComponent,
    BannerComponent,
    ReporteDetalleComponent,
    ReporteDetallePaisComponent,
    UsuarioComponent,
    BannerregistradosComponent,
    BannerusuarioComponent,
    LoadingComponent,
    FooterComponent,
    RedireccionComponent
  ],
  imports: [
    RouterModule,
    HighchartsChartModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    QRCodeModule,
    FormsModule,
    NgxChartsModule,
    NgxPaginationModule,
    BrowserAnimationsModule, // required animations module
 
    ToastrModule.forRoot(), // ToastrModule added
    NgxBootstrapIconsModule.pick(allIcons)
  ],
  providers: [
    {provide:LocationStrategy, useClass: HashLocationStrategy},
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
